// extracted by mini-css-extract-plugin
export var root = "_zr-0";
export var scroll = "_zr-1";
export var thumb = "_zr-3";
export var track = "_zr-2";